import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import isEmpty from '../../validation/is-empty';
import Spinner from '../common/Spinner';
import { setUpQuestionConfig } from '../../actions/vipQuestionActions';
import './vipservice.css';
class VipServiceHome extends Component {
 componentDidMount() {
    const search_values = queryString.parse(this.props.location.search);
    //console.log("VipServiceHome componentDidMount", this.props.location.search);
    // console.log(
    //   "search_values",
    //   decodeURIComponent(this.props.location.search)
    // );
    
    this.props.setUpQuestionConfig(
      {
        search_string: decodeURIComponent(this.props.location.search),
      },
      search_values.token
    );
    document.title = '龍邑遊戲|客服首頁';
  }
  
  componentDidUpdate(prevProps) {
    if (this.props.vipService.game_name !== prevProps.vipService.game_name) {
      document.title = `龍邑遊戲|${this.props.vipService.game_name}【專屬玩家】`;
    }
  }

  render() {
    //const game_id = this.props.match.params.game_id;
    let game_id = this.props.vipService.game_id;
    
    const {
      is_in_game,
      unread_count,
      game_name,
      token,
      loading,
      isVipreportWhitelisted,
      vip_ranking,
      member_link,
    } = this.props.vipService;
    
    const parsed = queryString.parse(this.props.location.search);
    // console.log('game_name', game_name);
    // console.log('is_in_game', is_in_game);
    if (!isEmpty(parsed.param_game_id)) {
      game_id = parsed.param_game_id;
    }
    if (game_id === undefined) {
      game_id = parsed.game_id;
    }

    const linkVipReport = is_in_game
      ? `/vipservice/${game_id}/create?token=${token}`
      : `/vipservice/${game_id}/create`;

    const linkVipQuery = is_in_game
      ? `/vipservice/${game_id}/list?token=${token}`
      : `/vipservice/${game_id}/query`;

    // console.log(game_id);
    // console.log(game_id === undefined);
    if (game_name === undefined) {
      this.props.history.push('./support');
    }

    return (
      <div>
        <nav className='navbar navbar-dark bg-dark'>
          <div className='container text-center'>
            <span className='navbar-brand mb-0 h1 navbar-text m-auto'>
              {game_name}客服中心【專屬玩家】
            </span>
            {/*(member_link &&
              <a href="/members"><button className="btn btn-warning btn-lg">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;會員中心&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</button></a>
            )*/}
          </div>
        </nav>
        {//vip_ranking && isVipreportWhitelisted ? (
        vip_ranking ? (
          loading ? (
            <Spinner />
          ) : (
            <div className='container' style={{ marginTop: '50px' }}>
              <div className='row'>
                <div className='col-md-12 text-center float-right'>
                  <hr />
                  
                  <div className='row justify-content-center'>
                    <div className='col-sm-6 col-xs-6 col-md-4'>                      
                      <Link to={linkVipReport} className='quick-button-vip'>
                        <i className='fas fa-edit' />
                        <p style={{ padding: '10px' }}>專屬回報</p>
                      </Link>
                      <div className='quick-button-vip-cover'></div>
                      <div style={{position: 'absolute', top:'-5px', left:'20px', fontSize:'32px', color:'white'}}>★</div>
                    </div>
                    <div className='col-sm-6 col-xs-6 col-md-4'>
                      <Link to={linkVipQuery} className='quick-button-vip'>
                        <i className='fa fa-file-text' />
                        <p style={{ padding: '10px' }}>回報紀錄</p>
                        {unread_count > 0 && (
                          <span className='notification red'>{unread_count}</span>
                        )}
                      </Link>
                    </div>
                  </div>
                  
                  <div className='row justify-content-center'>
                    {is_in_game && (
                      <div className='col-md-12 alert alert-warning m-2'>
                        提醒您：若無法選取檔案回報，請直接利用官網線上提問。
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )
        ) : (
          <div className='container' style={{ marginTop: '50px' }}>
            <div className='row'>
              <div className='col-md-12 text-center float-right'>
                <hr />
                <div className='row justify-content-center'>
                    <div className='col-md-12 alert alert-warning m-2'>
                      目前未開放使用喔!!
                    </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
VipServiceHome.defaultProps = {
  is_in_game: false,
  unread_count: 0,
};

VipServiceHome.propTypes = {
  setUpQuestionConfig: PropTypes.func.isRequired,
  vipService: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  vipService: state.vipService,
});

export default connect(mapStateToProps, { setUpQuestionConfig })(VipServiceHome);
